"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownIcon", {
    enumerable: true,
    get: function() {
        return DropdownIcon;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Dropdown = require("../Dropdown");
const _DropdownMenu = require("../DropdownMenu/DropdownMenu");
const _useSize = require("../../../util/useSize");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Inner = (param)=>{
    let { icon: Icon, hoverIcon: HoverIcon, size = "md", inverted = false, ...props } = param;
    const propSize = (0, _useSize.useSize)(size);
    const dropdown = (0, _react.useContext)(_Dropdown.DropdownContext);
    const { colors, isAdmin } = (0, _Theme.useTheme)();
    const iconSize = ()=>{
        switch(size){
            case "xs":
                return 10;
            case "sm":
                return 16;
            case "md":
                return 20;
            case "lg":
                return 50;
            case "xl":
                return 100;
            default:
                return 20;
        }
    };
    const onClick = ()=>{
        dropdown.setShow(!dropdown.show);
    };
    const onKeyDown = (e)=>{
        if (e.key === "Enter") {
            dropdown.setShow(!dropdown.show);
        }
    };
    const onMouseEnter = ()=>{
        if (props.isHoverTrigger === true) {
            dropdown.setShow(true);
        }
    };
    const onMouseLeave = ()=>{
        if (props.isHoverTrigger === true) {
            dropdown.setShow(false);
        }
    };
    const hoverColor = (0, _react.useMemo)(()=>{
        return isAdmin ? colors.grayscale[60] : colors.primary;
    }, [
        isAdmin,
        colors
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: dropdown.reference,
        onClick: onClick,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        className: _style.default.dynamic([
            [
                "cc4fa1b2b940906b",
                [
                    propSize,
                    propSize,
                    dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none",
                    dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark,
                    hoverColor,
                    inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover,
                    dropdown.show && HoverIcon !== undefined ? "none" : "inline-block",
                    HoverIcon !== undefined ? "none" : "block",
                    dropdown.show ? "block" : "none"
                ]
            ]
        ]) + " " + (props.className || "")
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "cc4fa1b2b940906b",
                [
                    propSize,
                    propSize,
                    dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none",
                    dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark,
                    hoverColor,
                    inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover,
                    dropdown.show && HoverIcon !== undefined ? "none" : "inline-block",
                    HoverIcon !== undefined ? "none" : "block",
                    dropdown.show ? "block" : "none"
                ]
            ]
        ])
    }, HoverIcon !== undefined && /*#__PURE__*/ _react.default.createElement(HoverIcon, {
        ...props,
        size: iconSize(),
        className: _style.default.dynamic([
            [
                "cc4fa1b2b940906b",
                [
                    propSize,
                    propSize,
                    dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none",
                    dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark,
                    hoverColor,
                    inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover,
                    dropdown.show && HoverIcon !== undefined ? "none" : "inline-block",
                    HoverIcon !== undefined ? "none" : "block",
                    dropdown.show ? "block" : "none"
                ]
            ]
        ]) + " " + "hover"
    }), /*#__PURE__*/ _react.default.createElement(Icon, {
        ...props,
        size: iconSize(),
        className: _style.default.dynamic([
            [
                "cc4fa1b2b940906b",
                [
                    propSize,
                    propSize,
                    dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none",
                    dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark,
                    hoverColor,
                    inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover,
                    dropdown.show && HoverIcon !== undefined ? "none" : "inline-block",
                    HoverIcon !== undefined ? "none" : "block",
                    dropdown.show ? "block" : "none"
                ]
            ]
        ]) + " " + "icon"
    }))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cc4fa1b2b940906b",
        dynamic: [
            propSize,
            propSize,
            dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none",
            dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark,
            hoverColor,
            inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover,
            dropdown.show && HoverIcon !== undefined ? "none" : "inline-block",
            HoverIcon !== undefined ? "none" : "block",
            dropdown.show ? "block" : "none"
        ]
    }, "div.__jsx-style-dynamic-selector{display:inline-block;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:".concat(propSize, "px;height:").concat(propSize, "px;background:").concat(dropdown.show ? inverted ? colors.white : colors.grayscale[5] : "none", ";-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;color:").concat(dropdown.show ? hoverColor : isAdmin ? inverted ? colors.white : colors.medium : inverted ? colors.white : colors.dark, "}span.__jsx-style-dynamic-selector{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}div.__jsx-style-dynamic-selector:hover{color:").concat(hoverColor, ";background:").concat(inverted ? colors.white : isAdmin ? colors.grayscale[5] : colors.lightHover, ";border:none}.icon.__jsx-style-dynamic-selector{display:").concat(dropdown.show && HoverIcon !== undefined ? "none" : "inline-block", "}div.__jsx-style-dynamic-selector:hover>span.__jsx-style-dynamic-selector>.icon.__jsx-style-dynamic-selector{display:").concat(HoverIcon !== undefined ? "none" : "block", "}.hover.__jsx-style-dynamic-selector{display:").concat(dropdown.show ? "block" : "none", "}div.__jsx-style-dynamic-selector:hover>span.__jsx-style-dynamic-selector>.hover.__jsx-style-dynamic-selector{display:block}")));
};
const DropdownIcon = /*#__PURE__*/ _react.default.forwardRef((param, _ref)=>{
    let { children, placement = "bottom-start", onSelect, fontWeight, fixedHeader, width, maxHeight, supportsMobile, ...props } = param;
    const { isAdmin } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_Dropdown.Dropdown, {
        placement: placement,
        onSelect: onSelect,
        fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : isAdmin ? "heavy" : "light",
        flip: true
    }, /*#__PURE__*/ _react.default.createElement(Inner, props), /*#__PURE__*/ _react.default.createElement(_DropdownMenu.DropdownMenu, {
        maxHeight: maxHeight,
        fixedHeader: fixedHeader,
        width: width,
        mobileView: supportsMobile === true ? "minimal" : undefined
    }, children)));
});
DropdownIcon.displayName = "DropdownIcon";

//# sourceMappingURL=DropdownIcon.js.map